export default {
    title: 'Settings',
    profile: 'My Profile',
    name: 'Name',
    company: 'School',
    email: 'Email',
    language: 'Language',
    logout: 'Log out',
};
